import { useSelector } from 'react-redux';
import { USER_DATA_KEY } from '../constants/AppConstants';
const useCheckRole = () => {
  const userRole = useSelector(st => st.auth?.userData?.role);

  const getRole = () => userRole || getCached()?.role;
  const _role = getRole();

  const isLoggedOutUser = () => _role === '' || !!!_role;
  const isUser = () => !isLoggedOutUser() && _role !== 'physician';
  const isPhysician = () => _role === 'physician';

  return { getRole, isUser, isPhysician, isLoggedOutUser };
}
const getCached = () => {
  try {
    const t = localStorage.getItem(USER_DATA_KEY);
    return t ? JSON.parse(t) : {};
  } catch (e) {
    return {};
  }

}
export default useCheckRole;